<template>
    <rkm-area
        v-if="cliente && cliente.ativoAppConectasusCidadao"
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-form-checkbox
                v-model="data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao"
                :disabled="bloqueiaAgendamentoApp"
            >
                Habilitar agendamento de exames de imagem no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite disponibilizar vagas de agendamento de exames de imagem no App do Cidadão. Quando desativado, o agendamento não é exibido no App, mesmo que esteja configurado.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>

        <rkm-alert
            v-if="controleJornadaPorExame"
            show
            color="warning"
            class="mt-2 mb-2"
        >
            O controle de jornada por exame não permite o agendamento pelo APP Cidadão.
        </rkm-alert>

        <template v-if="data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao">
            <rkm-alert show info class="mt-2 mb-2">
                Ao habilitar o APP Cidadão, configure as unidades que poderão receber agendamento e o percentual de cota disponível para o canal cidadão.
            </rkm-alert>

            <AppCidadaoPrestadores :data="data" />
        </template>

        <rkm-row class="mt-2">
            <rkm-form-checkbox v-model="data.model.integracaoAplicativo.habilitaConsultaImagemConectasusCidadao">
                Habilitar visualização de laudos de exames de imagem no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite que o cidadão visualize laudos de exames de imagem com resultado emitido no App do Cidadão. Quando desativado, os laudos não são exibidos no App.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>
    </rkm-area>
</template>

<script>
import {mapGetters} from 'vuex'
import AppCidadaoPrestadores from './components/AppCidadaoPrestadores'

import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'

export default {
    components: { AppCidadaoPrestadores },
    props: {
        data: { required: true, type: Object },
    },
    computed: {
        ...mapGetters({cliente: 'getCliente'}),

        controleJornadaPorExame() {

            return this.data.model.controleJornada === this.enums.tipoControleJornada.EXAME
        },

        bloqueiaAgendamentoApp() {

            return this.controleJornadaPorExame
                && !this.data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao
        },
    },
    data: () => ({
        enums: {
            tipoControleJornada
        },
    }),
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>